import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import type Facts from 'app/shared/models/Facts';

type AreaFactsInput = {
  perCapitaIncome?: number;
  populationDensity?: number;
  medianHouseholdIncome?: number;
  population?: number;
  medianAge?: number;
  squareMiles?: number;
  percentRenters?: number;
  listingCounts?: Record<string, string | number>;
};

type AreaFacts = AreaFactsInput | Facts;

const controller = {
  hasAreaArticles(articles: Array<unknown> = []): boolean {
    let hasArticles = false;

    if (!isEmpty(articles)) {
      hasArticles = true;
    }

    return hasArticles;
  },
  hasAreaFacts(facts: AreaFacts = {}): boolean {
    let hasFacts = false;

    if (facts.perCapitaIncome) {
      hasFacts = true;
    }

    if (facts.populationDensity) {
      hasFacts = true;
    }

    if (facts.medianHouseholdIncome) {
      hasFacts = true;
    }

    if (facts.population) {
      hasFacts = true;
    }

    if (facts.medianAge) {
      hasFacts = true;
    }

    if (facts.squareMiles) {
      hasFacts = true;
    }

    if (facts.percentRenters) {
      hasFacts = true;
    }

    return hasFacts;
  },
  hasAreaListings(facts: AreaFacts): boolean {
    let hasListings = false;
    const propertyTypes = omit(facts.listingCounts, 'DATA_MODEL') as Record<string, number>;

    forEach(propertyTypes, (listingCount) => {
      if (listingCount > 0) {
        hasListings = true;
      }
    });

    return hasListings;
  },
};

export default controller;
